import { Link, NavLink } from 'react-router-dom';
import cn from 'classnames';
import type { AnchorHTMLAttributes } from 'react';
import type { LinkProps, NavLinkProps } from 'react-router-dom';
import styles from './Link.module.scss';

export type AppLinkProps = LinkProps;
export type AppExternalLinkProps = AnchorHTMLAttributes<HTMLAnchorElement>;
export type AppNavLinkProps = Omit<NavLinkProps, 'className'> & {
  className?: string;
};

export const AppLink = ({ className, ...props }: LinkProps) => {
  return <Link {...props} className={cn(styles.link, className)} />;
};

export const AppExternalLink = ({ className, ...props }: AppExternalLinkProps) => {
  return <a {...props} className={cn(styles.link, className)} />;
};

export const AppNavLink = ({ className, ...props }: AppNavLinkProps) => {
  return (
    <NavLink
      {...props}
      className={({ isActive }) => cn(styles.link, isActive && styles.active, className)}
    />
  );
};
